import { render } from "./CreatePartnerProperty.vue?vue&type=template&id=4c0ce36e&ts=true"
import script from "./CreatePartnerProperty.vue?vue&type=script&lang=ts"
export * from "./CreatePartnerProperty.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__